"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _infoIcon = _interopRequireDefault(require("../../assets/infoIcon.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionTitle = function SectionTitle(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      _ref$isOptional = _ref.isOptional,
      isOptional = _ref$isOptional === void 0 ? false : _ref$isOptional,
      _ref$showInfoIcon = _ref.showInfoIcon,
      showInfoIcon = _ref$showInfoIcon === void 0 ? false : _ref$showInfoIcon,
      _ref$tooltipMessage = _ref.tooltipMessage,
      tooltipMessage = _ref$tooltipMessage === void 0 ? '' : _ref$tooltipMessage;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, title), isMandatory ? '*' : '', "\xA0", isOptional && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '1rem',
      color: '#6b7280'
    }
  }, ' (Optional) '), showInfoIcon && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: tooltipMessage,
    position: "right"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _infoIcon.default,
    style: {
      height: '18px'
    }
  }))));
};

SectionTitle.propTypes = {
  title: _propTypes.default.string,
  isMandatory: _propTypes.default.bool,
  tooltipMessage: _propTypes.default.string,
  isOptional: _propTypes.default.bool,
  showInfoIcon: _propTypes.default.bool
};
var _default = SectionTitle;
exports.default = _default;